"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Tooltip = _interopRequireDefault(require("../../Tooltip"));

function Button(_ref, ref) {
  var className = _ref.className,
      active = _ref.active,
      tooltip = _ref.tooltip,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className", "active", "tooltip"]);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
    tabIndex: "-1"
  }, props, {
    ref: ref,
    type: "button",
    className: (0, _classnames["default"])(className, 'inline-flex  items-center p-1 border border-transparent focus:border-ultra-light rounded text-sm select-none     focus:bg-secondary hover:bg-secondary', {
      'text-primary': active,
      'hover:text-primary-active': active,
      'focus:text-primary-active': active,
      'bg-secondary': active,
      'text-gray-light': props.disabled
    })
  })));
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(Button);

exports["default"] = _default;
//# sourceMappingURL=Button.js.map